module.exports = __webpack_public_path__ + "static/home-slideshow-01-a6fe59f972b5f7ce205091c76a0f9e61.jpg";